import { createContext, default as React, useContext } from "react";
import { useCreateNavigationStateProvider } from "./useCreateNavigationStateProvider";
import { ThemeSettings } from "@kahunmedical/common-configuration";

export interface NavigationProvider {
  viewChanged: boolean;
  setViewChanged: (value: boolean) => void;
  showRetry: boolean;
  setShowRetry: (value: boolean) => void;
  retry: boolean;
  setRetry: (value: boolean) => void;
  themeSettings: ThemeSettings;
  setThemeSettings: (settings: ThemeSettings) => void;
  locale: string;
  setLocale: (locale: string) => void;
}

export interface NavigationContextProps {
  children?: React.ReactNode;
}

export const navigationContextObject = createContext(null);

export const NavigationContext = React.memo(
  ({ children = null }: NavigationContextProps) => {
    const ContextProvider = navigationContextObject.Provider;
    const state = useCreateNavigationStateProvider();
    return <ContextProvider value={state}>{children}</ContextProvider>;
  },
);

export const useNavigation: () => NavigationProvider = () =>
  useContext(navigationContextObject) || { themeSettings: {} };
